import { createAxiosInstance } from '@servicetitan/cp-api';
import { injectable, inject, optional } from '@servicetitan/react-ioc';
import { UsersClient } from './user-client';

export * from './user-client';

@injectable()
export class AuthApi {
    client: UsersClient;

    constructor(@inject('baseUrl') @optional() baseUrl?: string) {
        this.client = new UsersClient(baseUrl, createAxiosInstance());
    }
}
